export default __webpack_public_path__ + "static/media/duotone.8a062946.jpg";